import { createFileRoute } from '@tanstack/react-router'

import {
  getFormOptions,
  getFormVersionOptions,
} from '@/api/codegen/@tanstack/react-query.gen'
import { FormVersionPage } from '@/pages/forms/FormVersion.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/$formVersionId',
)({
  component: FormVersionPage,
  loader: async ({
    context: { queryClient },
    params: { projectId, formId, formVersionId },
  }) => {
    const form = await queryClient.ensureQueryData(
      getFormOptions({
        path: {
          projectID: projectId,
          formID: formId,
        },
        query: {
          expandRefs: true,
        },
      }),
    )
    const formVersion = await queryClient.ensureQueryData(
      getFormVersionOptions({
        path: {
          projectID: projectId,
          formID: formId,
          formVersionID: formVersionId,
        },
        query: {
          expandRefs: true,
        },
      }),
    )

    return {
      breadcrumbTitle: `${form.name} - V.${formVersion.version}`,
    }
  },
})
